
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/statistiky/tymu/[team]",
      function () {
        return require("private-next-pages/statistiky/tymu/[team].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/statistiky/tymu/[team]"])
      });
    }
  